import { useState } from "react";
import { SellerMemberDto, updateMemberMemo } from "../../../../api/member";
import { Overlay } from "../../../../styles/popup";
import * as S from "./style";
import { formatDate } from "../../../../utils/date";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";
import { exchangePoint } from "../../../../utils/number";

interface MemberDetailModalProps {
  member: SellerMemberDto;
  setMember: (value: SellerMemberDto | null) => void;
  refreshMemberList: () => void;
}

const MemberDetailModal = ({
  member,
  setMember,
  refreshMemberList,
}: MemberDetailModalProps) => {
  const pub = useRecoilValue(pubState);
  const [memo, setMemo] = useState(member.memo || "");

  const handleSave = async () => {
    if (!memo) return;
    try {
      await updateMemberMemo(member.id, memo);
      refreshMemberList();
      setMember(null);
      alert("메모가 저장되었습니다.");
    } catch (e) {
      console.error(e);
      alert("메모 저장에 실패했습니다.");
    }
  };

  return (
    <Overlay onClick={() => setMember(null)}>
      <S.MemberDetailModalWrapper onClick={(e) => e.stopPropagation()}>
        <S.MemberDetailModalHeader>
          {member.nickname}님
        </S.MemberDetailModalHeader>
        <S.MemberDetailInfoWrapper>
          <S.MemberDetailInfoHeader>
            <div className="item">가입날짜</div>
            <div className="item">참여횟수</div>
            <div className="item">E</div>
            <div className="item">RB</div>
            <div className="item">CR</div>
            <div className="item">주류마일리지</div>
          </S.MemberDetailInfoHeader>
          <S.MemberDetailInfoItem>
            <div className="item">{formatDate(member.createdAt)}</div>
            <div className="item">{member.count?.toLocaleString()}</div>
            <div className="item">{exchangePoint(member.point)}</div>
            <div className="item">{Number(member.seed).toLocaleString()}</div>
            <div className="item">
              {Number(member.carrot ?? 0).toLocaleString()}
            </div>
            <div className="item">
              {Number(member.mileage).toLocaleString()}
            </div>
          </S.MemberDetailInfoItem>
        </S.MemberDetailInfoWrapper>
        <S.MemberDetailMemoWrapper>
          <div className="label">메모</div>
          <textarea
            placeholder="메모를 입력해주세요"
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
          />
        </S.MemberDetailMemoWrapper>
        <S.MemberDetailButtonWrapper>
          <div onClick={() => setMember(null)}>닫기</div>
          <div className="save" onClick={() => handleSave()}>
            저장
          </div>
        </S.MemberDetailButtonWrapper>
      </S.MemberDetailModalWrapper>
    </Overlay>
  );
};

export default MemberDetailModal;
